'use strict';
// Native forms remain functional without JavaScript.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.nav-dropdown[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

